import { systemMessageOperations } from 'ducks/systemMessage';
import * as actions from './actions';

export const submitSubscribeForm = (data) => (dispatch) =>
	dispatch(
		systemMessageOperations.withSystemMessage(
			dispatch(actions.submitSubscribeForm(data)),
			'Вы\u00A0подписались на\u00A0рассылку портала «Культура.РФ». Спасибо! Осталось подтвердить подписку\u00A0— мы\u00A0отправили ссылку на\u00A0вашу электронную почту.',
			'При отправке произошла ошибка. Попробуйте еще\u00A0раз.'
		)
	);
